// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PremiumMenu.css */
.premium-menu {
  position: fixed;
  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */
  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 5px;
  padding-bottom: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1120;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.premium-menu {
  scrollbar-width: thin;
  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);
}

.premium-menu,
.premium-menu * {
  touch-action: pan-y;
}

.premium-menu::-webkit-scrollbar {
  display: block;
  width: 8px;
}

.premium-menu::-webkit-scrollbar-track {
  background: var(--tg-theme-bg-color);
}

.premium-menu::-webkit-scrollbar-thumb {
  background-color: var(--tg-theme-hint-color);
  border-radius: 4px;
}

/* Titles and Text */
.premium-menu-title {
  font-size: 23px;
  font-weight: bold;
  margin-bottom: 0px;
  text-align: center;
  color: var(--tg-theme-button-color); /* Синий цвет */
}

.premium-item {
  margin: 5px;
  padding: 5px 8px;
  background-color: var(--tg-theme-secondary-bg-color);
  border-radius: 12px;
  width: 90%;
}

.premium-info {
  margin-bottom: 2px;
}

.premium-name {
  font-size: 20px;
  font-weight: bold;
  color: var(--tg-theme-text-color);
  text-align: left;
}

.premium-description {
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 0px;
  margin-top: 2px;
  margin-bottom: 0px;
  text-align: left;
}

.feature-info {
  margin-bottom: 10px;
}

.feature-name {
  font-size: 22px;
  font-weight: bold;
  color: var(--tg-theme-text-color);
}

.feature-description {
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 0px;
  margin-top: 7px;
  margin-bottom: 0px;
  /* background-color: #4eca7d; */
}

`, "",{"version":3,"sources":["webpack://./src/components/menus/premium/PremiumMenu.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB,EAAE,6CAA6C;EAC/D,gBAAgB,EAAE,uDAAuD;;EAEzE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oEAAoE;AACtE;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC,EAAE,eAAe;AACtD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oDAAoD;EACpD,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC","sourcesContent":["/* PremiumMenu.css */\r\n.premium-menu {\r\n  position: fixed;\r\n  max-height: 95vh; /* Максимальная высота 90% от высоты экрана */\r\n  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */\r\n\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 350px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 5px;\r\n  padding-bottom: 12px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1120;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.premium-menu {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--tg-theme-hint-color) var(--tg-theme-bg-color);\r\n}\r\n\r\n.premium-menu,\r\n.premium-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.premium-menu::-webkit-scrollbar {\r\n  display: block;\r\n  width: 8px;\r\n}\r\n\r\n.premium-menu::-webkit-scrollbar-track {\r\n  background: var(--tg-theme-bg-color);\r\n}\r\n\r\n.premium-menu::-webkit-scrollbar-thumb {\r\n  background-color: var(--tg-theme-hint-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Titles and Text */\r\n.premium-menu-title {\r\n  font-size: 23px;\r\n  font-weight: bold;\r\n  margin-bottom: 0px;\r\n  text-align: center;\r\n  color: var(--tg-theme-button-color); /* Синий цвет */\r\n}\r\n\r\n.premium-item {\r\n  margin: 5px;\r\n  padding: 5px 8px;\r\n  background-color: var(--tg-theme-secondary-bg-color);\r\n  border-radius: 12px;\r\n  width: 90%;\r\n}\r\n\r\n.premium-info {\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.premium-name {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: var(--tg-theme-text-color);\r\n  text-align: left;\r\n}\r\n\r\n.premium-description {\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 0px;\r\n  margin-top: 2px;\r\n  margin-bottom: 0px;\r\n  text-align: left;\r\n}\r\n\r\n.feature-info {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.feature-name {\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  color: var(--tg-theme-text-color);\r\n}\r\n\r\n.feature-description {\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 0px;\r\n  margin-top: 7px;\r\n  margin-bottom: 0px;\r\n  /* background-color: #4eca7d; */\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
